import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {physicianGuard} from '@app/auth/guards/physician.guard';
import {pharmacistGuard} from '@app/auth/guards/pharmacist.guard';
import {EuComponent} from '@modules/eu/pages/eu/eu.component';
import {CountryComponent} from '@modules/eu/country/pages/country/country.component';
import {PatientComponent} from '@modules/eu/country/patient/pages/patient/patient.component';
import {PSRoutes} from '@modules/eu/country/patient/ps/ps-routing.module';
import {physicianPharmacistGuard} from '@app/auth/guards/physician-pharmacist.guard';

export const patientRoutes: Routes = [
  {
    path: '',
    canActivate: [physicianPharmacistGuard],
    component: CountryComponent,
  },
  {
    path: 'patient',
    canActivate: [physicianPharmacistGuard],
    component: PatientComponent,
    children: PSRoutes,
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [RouterModule.forChild(patientRoutes)],
  exports: [RouterModule]
})
export class PatientRoutingModule { }
